mutation AddRevenueShareReportCorrection(
  $id: ID!
  $amount: Float!
  $description: String!
) {
  addRevenueShareReportCorrection(
    id: $id
    amount: $amount
    description: $description
  ) {
    id
    status
    reportAmount {
      value
      currency
      valueUSD
    }
    reportAmountInContractCurrency {
      value
      currency
      valueUSD
    }
    corrections {
      description
      createdAt
      amount {
        value
        currency
        valueUSD
      }
    }
  }
}
